import _defineProperty from "/home/circleci/neene-player/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
var genSorterStyle = function genSorterStyle(token) {
  var componentCls = token.componentCls,
    marginXXS = token.marginXXS,
    fontSizeIcon = token.fontSizeIcon,
    headerIconColor = token.headerIconColor,
    headerIconHoverColor = token.headerIconHoverColor;
  return _defineProperty({}, "".concat(componentCls, "-wrapper"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(componentCls, "-thead th").concat(componentCls, "-column-has-sorters"), _defineProperty({
    outline: 'none',
    cursor: 'pointer',
    // why left 0s? Avoid column header move with transition when left is changed
    // https://github.com/ant-design/ant-design/issues/50588
    transition: "all ".concat(token.motionDurationSlow, ", left 0s"),
    '&:hover': {
      background: token.tableHeaderSortHoverBg,
      '&::before': {
        backgroundColor: 'transparent !important'
      }
    },
    '&:focus-visible': {
      color: token.colorPrimary
    }
  }, "\n          &".concat(componentCls, "-cell-fix-left:hover,\n          &").concat(componentCls, "-cell-fix-right:hover\n        "), {
    background: token.tableFixedHeaderSortActiveBg
  })), "".concat(componentCls, "-thead th").concat(componentCls, "-column-sort"), {
    background: token.tableHeaderSortBg,
    '&::before': {
      backgroundColor: 'transparent !important'
    }
  }), "td".concat(componentCls, "-column-sort"), {
    background: token.tableBodySortBg
  }), "".concat(componentCls, "-column-title"), {
    position: 'relative',
    zIndex: 1,
    flex: 1
  }), "".concat(componentCls, "-column-sorters"), {
    display: 'flex',
    flex: 'auto',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&::after': {
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      content: '""'
    }
  }), "".concat(componentCls, "-column-sorters-tooltip-target-sorter"), {
    '&::after': {
      content: 'none'
    }
  }), "".concat(componentCls, "-column-sorter"), _defineProperty({
    marginInlineStart: marginXXS,
    color: headerIconColor,
    fontSize: 0,
    transition: "color ".concat(token.motionDurationSlow),
    '&-inner': {
      display: 'inline-flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    '&-up, &-down': {
      fontSize: fontSizeIcon,
      '&.active': {
        color: token.colorPrimary
      }
    }
  }, "".concat(componentCls, "-column-sorter-up + ").concat(componentCls, "-column-sorter-down"), {
    marginTop: '-0.3em'
  })), "".concat(componentCls, "-column-sorters:hover ").concat(componentCls, "-column-sorter"), {
    color: headerIconHoverColor
  }));
};
export default genSorterStyle;